import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'

import { SaveButton } from 'components/buttons'
import { ModalFooter } from 'components/modal'
import OrderFields from './order-fields'

export const BasePurchaseInfoForm = ({
  fields: { orderNumber, storeName, orderNumberNotAvailable },
  handleSubmit,
  submitting,
  submitBtnText,
  registry,
  autofillStore,
  hideStoreInput,
}) => (
  <form onSubmit={handleSubmit} className="animated fadeIn animate-250ms">
    <OrderFields
      storeName={storeName}
      autofillStore={autofillStore}
      hideStoreInput={hideStoreInput}
      orderNumber={orderNumber}
      orderNumberNotAvailable={orderNumberNotAvailable}
      registry={registry}
    />
    <ModalFooter>
      <SaveButton block pill submitting={submitting} type="submit">
        {submitBtnText}
      </SaveButton>
    </ModalFooter>
  </form>
)

BasePurchaseInfoForm.propTypes = {
  autofillStore: PropTypes.bool,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hideStoreInput: PropTypes.bool,
  registry: PropTypes.object,
  submitting: PropTypes.bool.isRequired,
  submitBtnText: PropTypes.string,
}

BasePurchaseInfoForm.defaultProps = {
  autofillStore: false,
  hideStoreInput: false,
  submitBtnText: 'Done',
  registry: null,
}

const looksLikeUrl = (orderNumber) => {
  return (
    orderNumber.includes('www.') ||
    orderNumber.includes('.com') ||
    orderNumber.includes('http')
  )
}

const validate = (values) => {
  const errors = {}

  if (!values.orderNumber && !values.orderNumberNotAvailable) {
    errors.orderNumber =
      'Enter an order number or choose "I don\'t have an order number"'
  }

  if (values.orderNumber && looksLikeUrl(values.orderNumber)) {
    errors.orderNumber =
      'This looks like a website address, order numbers are short, like "#111-5564732-9109025" or "BLS-1234"'
  }

  return errors
}

export const PurchaseInfoForm = reduxForm(
  {
    form: 'purchaseInfo',
    fields: [
      'isPurchased',
      'orderNumber',
      'storeName',
      'orderNumberNotAvailable',
    ],
    validate,
  },
  (state, props) => {
    return {
      initialValues: {
        isPurchased: true,
        orderNumber: props?.reservation?.orderNumber || null,
        storeName: props.autofillStore ? props.storeName : null,
        orderNumberNotAvailable: false,
      },
    }
  }
)(BasePurchaseInfoForm)

PurchaseInfoForm.propTypes = {
  autofillStore: PropTypes.bool,
  reservation: PropTypes.object,
}

PurchaseInfoForm.defaultProps = {
  autofillStore: false,
  reservation: null,
}

export default PurchaseInfoForm
